var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      staticClass: "modal-full-color-success",
      attrs: {
        id: "imc_main_modal",
        "no-close-on-backdrop": true,
        title: "Коригування Аватари",
        size: "lg",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ ok, cancel }) {
            return [
              _c(
                "b-button",
                {
                  staticClass:
                    "btn btn-lg btn-outline-primary waves-effect waves-themed",
                  attrs: { size: "xl", variant: "primary-outline" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.close_editor()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "fal fa-check mr-1" }),
                  _vm._v("\n\t\t\tГотово\n\t\t"),
                ]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.show_modal,
        callback: function ($$v) {
          _vm.show_modal = $$v
        },
        expression: "show_modal",
      },
    },
    [
      _c("file-pond", {
        ref: "pond",
        attrs: {
          name: "user_avatar",
          server: _vm.getConfig(),
          "label-idle": "Додати файл (натисніть або перетяніть файл)",
          imageEditEditor: _vm.myDoka,
          files: _vm.myFiles,
        },
        on: { init: _vm.handleFilePondInit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }